<template>
    <Paper style="overflow: hidden;">
        <div v-if="error">
            <h3 class="text-center p-4">Sorry, something went wrong.</h3>
        </div>
        <div id="bp_error" style="display: none;">Sorry, something went wrong</div>
        <div id="bp_div"></div>
    </Paper>
</template>

<script>
import ReferralsService from '~/services/ReferralsService';
import I18nService from '~/services/I18nService';

export default {
    name: 'BuyapowaRefer',
    data: () => ({
        metaElement: null,
        scriptElement: null,
        error: false,
    }),

    mounted() {
        // TODO: Add skeleton loader if possible
        this.addEmbedScript();
    },

    destroyed() {
        this.removeEmbedScript();
    },

    methods: {
        // Called when Buyapowa library is loaded
        loadBuyapowa: async function() {
            try {
                const [customerData, locale] = await Promise.all([
                    ReferralsService.getSignature(),
                    I18nService.getLocale(),
                ]);

                let buyapowa = new Buyapowa(
                    { url: 'https://rafbp.gethighered.global', market: 'highered' },
                    'bp_div',
                    'bp_error'
                );

                buyapowa.embedReferAFriend({
                    campaign: 'highered_raf1',
                    locale,
                    auto: true,
                    signed_keys: 'custom_field, email, name',
                    ...customerData.data,
                });
                this.error = false;
            } catch (error) {
                this.error = true;
            }
        },

        // Adds Buyapowa library according to: https://tech.buyapowa.com/docs/#embed-your-campaign
        // Calls this.loadBuyapowa when library is loaded
        addEmbedScript: function() {
            this.metaElement = document.createElement('meta');
            this.metaElement.setAttribute('property', 'og:url');
            this.metaElement.setAttribute(
                'content',
                'https://rafbp.gethighered.global/iaf/highered/og'
            );
            document.head.appendChild(this.metaElement);

            this.scriptElement = document.createElement('script');
            this.scriptElement.setAttribute('src', '//cdn.co-buying.com/embedding.min.js');
            this.scriptElement.onload = this.loadBuyapowa;
            document.head.appendChild(this.scriptElement);
        },

        // Removes embed script when component is unmounted
        removeEmbedScript: function() {
            document.head.removeChild(this.scriptElement);
            document.head.removeChild(this.metaElement);
        },
    },
};
</script>

<style></style>
